export default {
  address: '주소는 10개까지 입력가능하며, 많아질수록 분석시간이 길어집니다.',
  project_name: `'목록' 탭에서 확인하고 검색할 수 있습니다.`,
  grade: `추진가능성을 선택하세요.<br>보고서 목록에서 고객을 더 편리하게 관리할 수 있습니다.`,
  examine: `우측 조례 내용 중 필요한 정보 발췌 후 복사하여 붙여넣거나 입력하세요.<br>보고서에 작성한 내용이 출력됩니다.`,
  memo: `최종 검토의견을 작성해보세요.<br>보고서에 작성한 내용이 출력됩니다.`,
  plant_type: '여러 지목이 있는 부지이면 ‘토지’로 판단합니다.',
  expect_capacity: '기본용량은 첫번째 주소지에 면적기준으로 계산되지만 부정확하므로 꼭 확인 후 재입력하시기 바랍니다.',
  review_result: '‘조례정보’를 클릭해 관련 조례 내용을 입력할 수 있습니다. <br> ‘검토의견’를 클릭해 사업지분석에 대한 전반적인 의견을 보고서에 넣을 수 있습니다.',
  unit_price: 'kW당 공사비 입력 시 총 공사비가 자동 계산됩니다.',
  install_fee: '용량과 kW당 공사비를 기준으로 자동 계산됩니다.',
  connect_fee:
    `<a href="javascript:void(0);" onclick="window.open('https://online.kepco.co.kr/PRM076D00', 'preview', 'menubar=0, resizable=0, width=1280, height=720'); return false;">표준시설부담금 계산기</a>를 이용해 입력해보세요.`,
  business_etc_fee: '공사비 외에 토목비 등 추가 비용이 있으면 입력하세요.',
  business_total_cost: '총 공사비, 계통연계비, 착수금, 토지비, 대출수수료, 기타사업비를 합한 총 사업비용입니다.',
  om_fee:
    `<p>매년 지출되는 안전관리자 선임료, 통신료, 보험료 등을 입력하세요.</p>` +
    `<p>자동계산 클릭시 100kW당 250만원으로 입력됩니다.</p>`,
  smp_price:
    `<p>` +
    `<a href="javascript:void(0);" onclick="window.open('http://home.kepco.co.kr/kepco/CO/D/E/CODEPP002/list.do?menuCd=FN04040502', 'preview', 'menubar=0, resizable=0, width=1280, height=720'); return false;">한전, </a>` +
    `<a href="javascript:void(0);" onclick="window.open('https://www.kpx.or.kr/www/contents.do?key=225', 'preview', 'menubar=0, resizable=0, width=1280, height=720'); return false;">전력거래소</a>` +
    `의 SMP단가를 참고하여 입력하세요.` +
    `</p>` +
    `<p>기본값으로는 최근 1년 평균값이 입력됩니다.</p>`,
  business_period: `입력한 기간까지의 SMP 수익을 계산합니다.<br>25년까지 입력이 가능합니다.`,
  rec_price:
    `<p>` +
    `<a href="javascript:void(0);" onclick="window.open('http://onerec.kmos.kr/portal/rec/selectRecReport_tradePerformanceList.do?key=1971&isExistCntntsFile=true', 'preview', 'menubar=0, resizable=0, width=1280, height=720'); return false;">전력거래소</a>` +
    `의 REC단가를 참고하여 입력하세요.` +
    `</p>` +
    `<p>기본값으로는 최근 1년 평균값이 입력됩니다.</p>`,
  rec_period: `입력한 기간까지의 REC 수익을 계산합니다.<br>25년까지 입력이 가능합니다.`,
  rec_weight: '용량과 사업지유형을 기준으로 자동 계산됩니다.',
  average_generate_time: '해줌 알고리즘 적용 버튼 클릭시 향, 각도, 음영손실, 운휴일을 반영한 발전시간1을 확인 및 적용할 수 있습니다.',
  average_generate_time2: '발전시간1과 발전시간2일 때의 수익결과를 비교할 수 있습니다.',
  aspect: '태양광 모듈이 향하는 곳이 180도는 남향이며, 90도로 갈수록 동향, 270도로 갈수록 서향입니다.',
  tilt_angle: '태양광 모듈의 각도를 입력하세요. (0 ~ 90)',
  shade_lose: '음영에 따라 발전량이 손실되는 비율을 입력하세요.',
  suspension_date_cnt: '연평균 운휴일을 입력하세요.',
  business_type: '사업자유형에 따라 세금 등 비용이 달라집니다.',
  loan_rate: '대출비율을 입력하면 대출금액이 자동 계산됩니다.',
  loan: '총 사업비와 대출비율을 기준으로 자동 계산됩니다.',
  loan_rate2: '대출비율2를 입력하면 대출비율1과의 수익을 비교할 수 있습니다.',
  redemption_period: '대출이 있을 경우 상환기간을 입력하세요.',
  module: '해줌에서 제공하는 모듈의 카탈로그를 보고서에 넣을 수 있습니다.(최대 3개)',
  inverter: '해줌에서 제공하는 인버터의 카탈로그를 보고서에 넣을 수 있습니다.(최대 3개)',
  reference_file: '설치사례 등 참고사진을 최대 8개까지 보고서에 삽입할 수 있습니다.',
  spot_photo_file: '현장사진을 최대 8개까지 보고서에 삽입할 수 있습니다.'
}



// WEBPACK FOOTER //
// ./src/assets/js/condition-tooltip.js